import { Dropdown } from "components/Common/Dropdown";
import React from "react";
import { SettingsDrawerEntryWrapper } from "./SettingsDrawerEntryWrapper";

export const SettingsDrawerDropdown = ({ config, value, setTempUser }) => {
  const { options, key } = config;

  return (
    <SettingsDrawerEntryWrapper {...config}>
      <Dropdown
        items={options}
        selected={value}
        setSelected={(v) => setTempUser((prev) => ({ ...prev, [key]: v }))}
      />
    </SettingsDrawerEntryWrapper>
  );
};
